import { Box, Text, useColorModeValue } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import CommonPagination from 'components/commonPagination/CommonPagination';
import CommonTable from 'components/commonTable/CommonTable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

const PowerbankOnlineOfflineList = ({ tableData, isLoader, page, setPage }) => {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor((row) => row?.onlineTime, {
      id: 'onlineTime',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          width="90px"
          fontFamily="Montserrat"
          whiteSpace="nowrap"
        >
          Online Time
        </Text>
      ),
      cell: (info) => {
        const onlineTime = info.getValue();
        const formattedDateTime = moment
          .parseZone(onlineTime)
          .format('DD-MM-YYYY HH:mm:ss');
        return (
          <Text
            color={textColor}
            fontSize="sm"
            fontWeight="600"
            align="left"
            whiteSpace="nowrap"
          >
            {formattedDateTime}
          </Text>
        );
      },
    }),
    columnHelper.accessor((row) => row?.offlineTime, {
      id: 'offlineTime',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          fontFamily="Montserrat"
          whiteSpace="nowrap"
        >
          Offline Time
        </Text>
      ),
      cell: (info) => {
        const offlineTime = info.getValue();
        const formattedDateTime = moment
          .parseZone(offlineTime)
          .format('DD-MM-YYYY HH:mm:ss');
        return (
          <Text
            color={textColor}
            fontSize="sm"
            fontWeight="600"
            align="left"
            whiteSpace="nowrap"
          >
            {formattedDateTime}
          </Text>
        );
      },
    }),
    columnHelper.accessor((row) => row?.duration, {
      id: 'duration',
      header: () => (
        <Text
          align="left"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
          fontFamily="Montserrat"
          whiteSpace="nowrap"
        >
          Duration
        </Text>
      ),
      cell: (info) => {
        return (
          <Text color={textColor} fontSize="sm" fontWeight="600">
            {info.getValue()}
          </Text>
        );
      },
    }),
  ];
  return (
    <>
      <Box>
        <CommonTable
          columns={columns}
          data={tableData?.list}
          isLoading={isLoader}
        />
        {/* {tableData?.total > 10 && ( */}
        <CommonPagination
          totalCount={tableData?.total}
          activePage={page}
          pageCount={Math.ceil(tableData?.total / tableData?.limit)}
          onPageChange={(e) => setPage(e)}
          itemsPerPage={tableData?.limit}
        />
        {/* )} */}
      </Box>
    </>
  );
};
PowerbankOnlineOfflineList.propTypes = {
  tableData: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.object),
    total: PropTypes.number,
    limit: PropTypes.number,
  }),
  isLoader: PropTypes.bool,
  page: PropTypes.number,
  setPage: PropTypes.func,
};

export default PowerbankOnlineOfflineList;
